import React from "react";

import { Navigate } from "react-router-dom";

import { COVERAGE_OPS_PATH } from "../../Utils/Constants/RoleConstants";
import { orgPath } from "../../Utils/Helper/orgPath";

/** Old /coverage links open the Executive Operations tab. */
const CoveragePage: React.FC = () => (
  <Navigate to={orgPath(COVERAGE_OPS_PATH)} replace />
);

export default CoveragePage;
